module.exports = __webpack_public_path__ + "static/media/DOCUMENTAÇÃO_DAS_ANÁLISES.5ee274db.pdf";